import { render, staticRenderFns } from "./ServicePointAdmin.vue?vue&type=template&id=3d914558&scoped=true"
import script from "./ServicePointAdmin.vue?vue&type=script&lang=js"
export * from "./ServicePointAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d914558",
  null
  
)

export default component.exports